import * as API from '../../services/API';
import AVAILABLE_LANGUAGES from 'Constants/Languages';

const getCustomLabels = async (language, channelId, propertyCode) => {
    try {
        const result = await API.getCustomLabels({ languageCode: language, channelId, propertyCode });
        const customLabels = result?.data?.result || {};
        const customLabelsForLang = pickCustomLabelsByLanguage(language, customLabels);
        return simplifyCustomLabels(customLabelsForLang);
    } catch(e) {
        /** we ignore this case -> failing custom labels is no reason to fail the widget loading */
    }

    return {};
};

const pickCustomLabelsByLanguage = (languageCode, customLabels) => {
    const customLabelsKey = Object.keys(customLabels)
        .find(key => key.toLocaleLowerCase() === languageCode);

    return customLabelsKey ? customLabels[customLabelsKey] : {};
};

export const simplifyCustomLabels = (customLabels) => {
    const result = {};
    Object.keys(customLabels).forEach(key => {
        const value = customLabels[key];

        if (typeof value === 'string') {
            result[key] = value;
        } else if (typeof value === 'object') {
            if (value?.other) {
                result[key] = value.other;
            }
        }
    });

    return result;
};

export function translationsRequestStart() {
    return { type: 'TRANSLATIONS_REQUEST_START' };
}

export function translationsRequestSuccess(response) {
    return { type: 'TRANSLATIONS_REQUEST_SUCCESS', payload: response };
}

export function translationsRequestFailure(data) {
    return { type: 'TRANSLATIONS_REQUEST_FAILURE', payload: data };
}

export function toggleShouldTakeFromApi() {
    return { type: 'TOGGLE_SHOULD-TAKE_FROM_API' };
}

export const getTranslations = (language, channelId, propertyCode) => async (dispatch) => {
    try {
        dispatch(translationsRequestStart());
        // if language is not in AVAILABLE_LANGUAGES, default language (AVAILABLE_LANGUAGES[0] => en) will be loaded
        const validLanguage = AVAILABLE_LANGUAGES.includes(language.toLowerCase()) ? language.toLowerCase() : AVAILABLE_LANGUAGES[0];
        const response = await API.getTranslations(validLanguage);
        const customLabels = await getCustomLabels(validLanguage, channelId, propertyCode);

        dispatch(translationsRequestSuccess({ ...response, ...customLabels }));
        return response;
    } catch (e) {
        return dispatch(translationsRequestFailure(e));
    }
};

export const isTranslationAvailable = key => (dispatch, getState) => !!(getState().translations.data[key]);

export default getTranslations;
